import { render } from "./WOrdenesCompra.vue?vue&type=template&id=6e7cc49d&scoped=true"
import script from "./WOrdenesCompra.vue?vue&type=script&lang=js"
export * from "./WOrdenesCompra.vue?vue&type=script&lang=js"

import "./WOrdenesCompra.vue?vue&type=style&index=0&id=6e7cc49d&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7cc49d"]])

export default __exports__